module.exports = __webpack_public_path__ + "img/uz.db7de2d4.svg";